// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29128":"fa99bdc2","37396":"47d52908","54825":"6de19ca0"}[chunkId] + ".chunk.css";
};